module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-600italic.6d10b80529d5c36c7c09fca7193af0fc.woff2";